export const sortationDefaultStyles = {
  base: {
    baseColor: '#ECEDF0',
    baseColorOpacity: 100,
    // baseOutline,
    // baseOutlineColor,
    baseBorderRadius: 10,
    score: true,
    showCorrectAnswer: false,
    panelBackground: '#282A2B',
    panelBackgroundDragging: '#949595',
    textColor: '#fff',
    textColorDragging: '#000',
    optionBorderRadius: 5,
    optionBackgroundOpacity: 100,
    optionBackgroundOpacityDragging: 100,
    optionOutline: false,
    optionOutlineColor: '',
    includeText: true,
    imagePosition: 'top',
  },
};

type TSortationDefaultStyles = {
  baseColor: string;
  baseColorOpacity: number;
  baseOutline: string;
  baseOutlineColor: string;
  baseBorderRadius: number;
  score: 0 | 1 | boolean;
  showCorrectAnswer: 0 | 1 | boolean;
  panelBackground: string;
  panelBackgroundDragging: string;
  textColor: string;
  textColorDragging: string;
  optionBorderRadius: number;
  optionBackgroundOpacity: number;
  optionBackgroundOpacityDragging: number;
  optionOutline: boolean;
  optionOutlineColor: string;
  includeText: boolean;
  imagePosition: string;
};

export const getDefaultStyles = (version = 'base') => {
  // throw. or return empty object with warning ???
  return (sortationDefaultStyles[version] || {}) as TSortationDefaultStyles;
};
